import { LogLevel, MapSSO } from "@moodys-ma-platform/auth-sdk";
import { isDevEnv } from "../utils/isDevEnv";
import { resolveVariable } from "../utils/config.utils";
const getRedirectUri = () => {
    return ["localhost", "moodys.com"].some((domain) => window.location.hostname.includes(domain))
        ? window.location.origin
        : resolveVariable("MDC_ORIGIN", "");
};
export const mapSSO = new MapSSO({
    clientId: resolveVariable("MAP_CLIENT_ID", "FAKE_CLIENT_ID"),
    redirectUri: getRedirectUri(),
    ...(isDevEnv() ? { logLevel: LogLevel.DEBUG } : {}),
    issuer: resolveVariable("MAP_ISSUER", "https://login.map-npe.moodys.com"),
    services: {
        syncStorage: true,
        autoRenew: true,
    },
});
//# sourceMappingURL=mapAuthProvider.js.map